var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenuConversions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.014,
    height: 19.266,
    viewBox: "0 0 14.014 19.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dollar",
    transform: "translate(-69.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10319",
    "data-name": "Path 10319",
    d: "M75.1,245.314v4.922l3.387-1.508v-3.413L83.8,240H69.789Z",
    transform: "translate(0 -230.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10320",
    "data-name": "Path 10320",
    d: "M241.564,2.822a.564.564,0,0,0,0,1.129,1.689,1.689,0,0,1,.564,3.283V7.9h2.42a4.541,4.541,0,0,0-2.42-7.9V1.8a1.691,1.691,0,0,1,1.129,1.589h-1.129A.565.565,0,0,0,241.564,2.822Z",
    transform: "translate(-164.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10321",
    "data-name": "Path 10321",
    d: "M136,4.516A4.551,4.551,0,0,0,137.531,7.9h2.42V7.234a1.691,1.691,0,0,1-1.129-1.589h1.129a.564.564,0,1,0,.564-.564,1.689,1.689,0,0,1-.564-3.283V0A4.558,4.558,0,0,0,136,4.516Z",
    transform: "translate(-63.72)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuConversions);
export default __webpack_public_path__ + "static/media/icon-menu-conversions.86827f67c2f59b24f378fb8183cbf08e.svg";
export { ForwardRef as ReactComponent };